define('BookingEngine/app-OtherCruises/main',['./settings', '../app-General/dialog', '../app-BookNow/main', '../app-BEBasket/module', '../../app-Loader/main'], function (settings, dialog, booknow, beBasket, loader) {
    return {
        run: function () {
            var summary = $(settings.container);

            if (summary.length === 0) {
                window.log('Master Cabin module will not be available.');
                return;
            }

            window.log('Loading cabin details');

            // Show deckplan in lightbox
            $(document).on("click", ".deckPlan", function (event) {
                event.preventDefault();
                dialog.showDialog(settings.deckplans);
            });

            // open/close master cabin grade pods
            $(document).on("click", ".cabingradepod", function (e) {
                e.preventDefault();

                var $thispodinfo = $(this).next(".cabingradepodInfo");

                $('.cabingradepodInfo').not($thispodinfo).removeClass("active").slideUp();
                $('.cabingradepod').not(this).removeClass("active");
                $(this).toggleClass("active");
                $($thispodinfo).toggleClass("active");

                $($thispodinfo).slideToggle("slow", function () {
                    $("html, body").animate({ scrollTop: $(this).offset().top }, 'slow', 'swing');
                });

                // Grades selected (like master grade on ocean)
                var gradeSelected = $(this).find('.numberCabins').text();
                gradeSelected = gradeSelected.substring(gradeSelected.indexOf("Grade"));

                $('#cabinGrade').text(gradeSelected);
                AdlAddUpdateItem("cabinGrade", gradeSelected);
                localStorage.setItem("cabinGrade", gradeSelected);
            });

            // Show deckplan in lightbox
            $(document).on("click", ".deckPlan", function () {
                $('.deckplancontent').toggle();
            });

            // choose a cabin
            $(document).on("click", ".cabinButton", function () {
                var $this = $(this);
                var chosenCabin = $(this).attr('class').split(' ').pop();
                var chosenGrade = $(this).closest('tr').find('.cabinsubgrade').text();
                var cabinDescription = $this.parents(".cabinTypes").find(".cabinsDescription").text();
                var cabinPickerActiveContainer = $("#pickyourcabinActive");

                cabinPickerActiveContainer.find(".cabinButton a").removeClass("btn-success").text("Choose cabin");
                $this.find("a").addClass("btn-success").text("Selected cabin");

                var selectedCabin = {
                    "Cabin": {
                        CabinGrade: $this.data("sub-grade"),
                        CabinUrl: "",
                        CabinDescription: cabinDescription,
                        CabinLocation: $this.data("location"),
                        CabinNo: $this.data("cabin-number"),
                        CabinSubGrade: $this.data("sub-grade"),
                        CabinPrice: $this.data("price"),
                        CabinBedType: $this.data("cabin-bed"),
                        CabinBathType: "",
                        CabinNotes: $this.data("cabin-notes"),
                        CabinDeck: $this.data("cabin-deck"),
                        RoomType: $this.data("sub-grade"),
                        AdaptedCabin: $this.data("adapted")
                    },
                    "DisplayPrice": $this.data("display-price").trim(),
                    "ShipCode": $this.data("ship-code")
                };

                // adobe
                AdlAddUpdateItem("BookingJourneyStep", "othercabin");
                AdlAddUpdateItem("cabinGrade", "grade " + chosenGrade + " cabin " + chosenCabin);
                localStorage.setItem("cabinGrade", "grade " + chosenGrade + " cabin " + chosenCabin);
                var occupancy = selectedCabin.Cabin.CabinBedType;
                AdlAddUpdateItem("occupancy", occupancy);
                localStorage.setItem("occupancy", occupancy);

                $('#occupancy').text(occupancy);

                loader.show("Reserving your cabin...");

                $.ajax({
                    url: settings.cabinsurl,
                    type: 'POST',
                    data: JSON.stringify(selectedCabin),
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    success: function (response) {
                        if (response.success === true) {
                            $('.chosencabininfo .cabinnumber').text(selectedCabin.Cabin.CabinNo);
                            $('.chosencabininfo .cabingrade').text(selectedCabin.Cabin.CabinGrade);
                            $('.chosencabininfo .cabindeck').text(selectedCabin.Cabin.CabinDeck);
                            $('.chosencabininfo .cabinprice').text(selectedCabin.DisplayPrice);
                            $('.chosencabininfo .cabindescription').text(selectedCabin.Cabin.CabinDescription);
                            $('.chosencabininfo .cabinbed').text(selectedCabin.Cabin.CabinBedType);
                            $('.chosencabininfo .cabinnocolumn').show();
                            $('.chosencabininfo .cabindeckcolumn').show();
                            $('.pickyourcabinSummary .chosentitle').text("cabin");
                            $('.changecabinpanel .cabinselection').text("cabin");
                            $('.pickyourcabinActive').hide();
                            $('.pickyourcabinSummary').show();
                            $('.pickyourcabinDisabled').hide();
                            booknow.ActivateBookNow();
                            beBasket.updateBasket();
                        } else {
                            console.log("There was an error:" + response.errorDetails);
                            loader.hide();
                        }
                    },
                    error: function (error) {
                        console.log("There was an error:" + error.errorDetails);
                        loader.hide();
                    }
                });
            });

            // choose a cabin sans cabin no...
            $(document).on("click", ".cabinGradeButton", function () {
                var $this = $(this);
                var chosenGrade = $this.data("grade");
                var chosenGradeDescription = $this.data("cabin-description");

                $("#pickyourcabinActive").find(".cabinGradeButton a").removeClass("btn-success").addClass("btn-primary").text("Choose cabin");
                $this.find("a").removeClass("btn-primary").addClass("btn-success").text("Selected cabin");

                var selectedCabin = {
                    "Cabin": {
                        CabinGrade: chosenGrade,
                        CabinUrl: "",
                        CabinDescription: chosenGradeDescription,
                        CabinLocation: "",
                        CabinNo: "",
                        CabinSubGrade: chosenGrade,
                        CabinPrice: $this.data("price"),
                        CabinBedType: "",
                        CabinBathType: "",
                        CabinNotes: "",
                        CabinDeck: "",
                        RoomType: chosenGrade
                    },
                    "DisplayPrice": $this.prev(".cabinprice").text(),
                    "ShipCode": $this.data("ship-code")
                };

                // adobe
                AdlAddUpdateItem("BookingJourneyStep", "othercabin");
                AdlAddUpdateItem("cabinGrade", chosenGrade);
                localStorage.setItem("cabinGrade", chosenGrade);

                loader.show("Reserving your cabin...");

                $.ajax({
                    url: settings.gradesurl,
                    type: 'POST',
                    data: JSON.stringify(selectedCabin),
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    success: function (response) {
                        if (response.success === true) {
                            // Insert into chosen cabin div
                            $('.chosencabininfo .cabinnumber').text("");
                            $('.chosencabininfo .cabingrade').text(selectedCabin.Cabin.CabinGrade);
                            $('.chosencabininfo .cabindeck').text(selectedCabin.Cabin.CabinDeck);
                            $('.chosencabininfo .cabinprice').text(selectedCabin.DisplayPrice);

                            $('.pickyourcabinSummary .chosentitle').text("grade");

                            $('.changecabinpanel .cabinselection').text("grade");
                            $('.chosencabininfo .cabinnocolumn').hide();
                            $('.chosencabininfo .cabindeckcolumn').hide();

                            $('.pickyourcabinActive').hide();
                            $('.pickyourcabinSummary').show();
                            $('.pickyourcabinDisabled').hide();

                            booknow.ActivateBookNow();
                            beBasket.updateBasket();
                        }
                    },
                    error: function (error) {
                        console.log("There was an error:" + error.errorDetails);
                        loader.hide();
                    }
                });
            });

            // change to a different cabin
            $(document).on("click", ".changecabinbtn", function () {
                if (!$('.cabingradepod').length) {
                    loader.show("Searching for cabins...");

                    $.get(settings.cruiseurl, function (response) {
                        if (response) {
                            $('#othercruisePickYourCabin').html(response);

                            // if this is a cruise, activate the Pick Your Cabin module
                            $('.pickyourcabinActive').show("slow", function () {
                                $('.pickyourcabinSummary').slideUp("slow", function () {
                                    $('.pickyourcabinDisabled').hide();
                                });
                            });
                        }

                        loader.hide();

                        // no Of Grades & Cabins
                        var noOfCabins = 0;
                        var noOfGrades = 0;

                        if ($(".numberCabins").length > 0) {
                            $(".numberCabins:visible").each(function () {
                                noOfGrades += 1;
                                var cabins = $(this).text();
                                noOfCabins = noOfCabins + parseInt(cabins);
                            });
                        } else if ($(".cabingrade:visible")) {
                            $(".cabingrade:visible").each(function () {
                                noOfGrades += 1;
                            });
                        }

                        AdlAddUpdateItem("numberOfGrades", noOfGrades.toString());
                        AdlAddUpdateItem("numberOfCabins", noOfCabins.toString());
                    });
                } else {
                    // if this is a cruise, activate the Pick Your Cabin module
                    $('.pickyourcabinActive').show();
                        $('.pickyourcabinSummary, .pickyourcabinDisabled').hide();
                    $("html, body").animate({ scrollTop: $(".pickyourcabinActive").offset().top - 15 });                                       

                    
                }

                // make sure all the pods are closed
                $('.cabingradepod').each(function () {
                    $(this).next(".cabingradepodInfo").css("display", "None");
                    $(this).removeClass("active");
                    $(this).next(".cabingradepodInfo").removeClass("active");
                });
            });

            window.loadedModules("BookingEngine/app-OtherCruises");
        }
    };
});
